export const START = "kyotech/loader/START";
export const STOP = "kyotech/loader/STOP";
export const REFRESH_START = "kyotech/loader/REFRESH_START";
export const REFRESH_STOP = "kyotech/loader/REFRESH_STOP";
